module.exports = __webpack_public_path__ + "static/media/tutor.27f076b6.svg";